<template>
  <div class="row photo-card">
    <div class="col-lg-9">
      <div class="image-wrapper">
        <photo :photo="photo"/>
      </div>
      <!--.image-wrapper -->
    </div>
    <!--.col -->
    <div class="col-lg-3">
      <h5 class="text-muted font-weight-light">{{photo.title}}</h5>
      <p class="font-italic small text-muted">{{photo.year}}</p>
      <p>{{photo.description}}</p>
      <delete-photo-link :photo="photo" v-if="deletePhoto"/>
    </div>
    <!--.info -->
  </div>
  <!--.row -->
</template>

<script>
import Photo from '@/components/Photo.vue'
import DeletePhotoLink from '@/components/DeletePhotoLink.vue'
export default {
  props: ['photo', 'deletePhoto'],
  components: { Photo, DeletePhotoLink },
  mounted() {
    if (this.photo) {
      // console.log(this.photo)
      this.$store.dispatch('photo/createGalleryThumb', this.photo)
    }
  }
}
</script>

<style scoped>
.photo-card {
  margin-bottom: 2.5em;
  margin-top: 2.5em;
  padding-bottom: 2.5em;
  border-bottom: 1px solid #dce1e6d6;
}
</style>
